import React, { ReactElement } from 'react'
import '../../../style/sass/common_kit/Text.scss'


export type ParagraphData = {
  className?: string
  text?: string,
  size?: TextSize,
  align?: Align
  fontWeight?: Weight,
  textStyle?: TextStyle,
  color?: string,
  children?: ReactElement
}


export enum Weight {
  NORMAL = 'normal',
  BOLD = 'bold',
  BOLDER = 'bolder'
}

export enum TextStyle {
  NORMAL = 'normal',
  ITALIC = 'italic'
}

export enum TextSize {
  P_10 = 'ui-kit-regular-10',
  P_11 = 'ui-kit-regular-11',
  P_12 = 'ui-kit-regular-12',
  P_14 = 'ui-kit-regular-14',
  P_16 = 'ui-kit-regular-16',
  P_18 = 'ui-kit-regular-18'
}

export enum Align {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}


export default function Paragraph({
  size: sizeProp = TextSize.P_14,
  align: alignProp = Align.LEFT,
  fontWeight: fontWeightProp = Weight.NORMAL,
  ...props
}: ParagraphData) {
  return (
    <p className={`${sizeProp} ${props.className ?? ''}`}
       style={{
         textAlign: alignProp,
         fontWeight: fontWeightProp,
         color: props.color ? props.color : '',
         fontStyle: props.textStyle
       }}>
      {props.text}
      {props.children}
    </p>
  )
}

